export default {
  trends: {
    title: "Tendencias",
    navigation: {
      gameSummary: "Resumen del partido",
    },
    tabs: {
      player: "Jugador",
      team: "Equipo",
      parlay: "Parlay",
      sgp: "SGP",
      stats: "Estadísticas",
    },
    help: {
      title: "Tendencias",
      description: "Linemate usa estas señales para mostrar la fuerza y el contexto detrás de cada tendencia.",
      items: {
        recentForm: "Tasa de éxito por forma reciente",
        headToHead: "Tasa de éxito cara a cara",
        homeAway: "Tasa de éxito en partidos de local y visitante",
        starter: "Tasa de éxito como titular (Linemate+)",
        injuryImpact: "Impacto de lesiones de compañeros (Linemate+)",
        opponentRank: "Ranking defensivo del rival",
      },
    },
    empty: {
      noTrendsAvailable: "No hay tendencias disponibles",
      clearFilters: "Borrar filtros",
      offseasonTitle: "Actualmente en temporada baja",
      minimumGames: "Se necesitan al menos 3 partidos",
    },
    analysis: {
      title: "Análisis de tendencia",
      viewProfile: "Ver perfil",
      addToMyPicks: "Agregar a Mis Picks",
      removeFromMyPicks: "Quitar de Mis Picks",
      addParlayToMyPicks: "Agregar parlay a Mis Picks",
      removeParlay: "Quitar parlay",
      addLegToMyPicks: "Agregar selección a Mis Picks",
      removeLegFromMyPicks: "Quitar selección de Mis Picks",
      sections: {
        playerForm: "Forma del jugador",
        playerPerformance: "Rendimiento del jugador",
        teamPerformance: "Rendimiento del equipo",
        teamForm: "Forma del equipo",
        startingLineup: "Alineación titular",
        injuries: "Lesiones",
        startingPitcher: "Lanzador abridor",
        batterVsPitcher: "Bateador vs lanzador",
        opponentDefensiveRank: "Ranking defensivo del rival",
        weather: "Clima",
        lockedAdvancedTools: "Obtén más con Linemate+",
        parlayLegs: "Selecciones",
      },
      labels: {
        status: "Estado",
        player: "Jugador",
        type: "Tipo",
        viewGames: "Ver partidos",
        quickCheckout: "Pago rápido",
        showAll: "Mostrar todo",
        close: "Cerrar",
        openOnProvider: "Abrir en {{provider}}",
        visitProvider: "Visitar {{provider}}",
        recentForm: "Forma reciente",
        headToHead: "Cara a cara",
        location: "Ubicación",
        lastFive: "Últimos 5",
        asStarter: "Como titular",
        startingPitcher: "Lanzador abridor",
        overallRank: "Ranking general",
        positionalRank: "Ranking posicional",
        confirmed: "Confirmado",
        expected: "Previsto",
        withoutPlayer: "Sin {{player}}",
        rankVsPosition: "Ranking vs {{position}}",
        impactOn: "Impacto en {{target}}",
        defensiveRankAgainst: "Ranking defensivo de {{team}} ‧ contra {{betType}}",
        vsPitcher: "vs {{pitcher}}",
        atBatsSummary: "{{value}} {{stat}} en {{atBats}} turnos al bate",
        gamesSuffix: " partidos",
        noSignalsFound: "No se encontraron señales para esta tendencia",
        noStarterSignal: "No hay señal de titular",
        noStartingLineupsYet: "Todavía no hay alineaciones titulares",
        noInjuryReportSignal: "No hay señal de reporte de lesiones",
        noInjuries: "Actualmente no hay lesiones",
      },
      summaryCards: {
        recentForm: "Forma reciente",
        headToHead: "Cara a cara",
        homeSplit: "Rendimiento en casa",
        awaySplit: "Rendimiento fuera",
        recordGames: "{{record}} partidos",
        recordVs: "{{record}} vs {{opponent}}",
        recordAtHome: "{{record}} en casa",
        recordAway: "{{record}} fuera",
      },
      paywall: {
        title: "Desbloquea el análisis completo de la tendencia",
        body: "Mira el impacto de cada señal avanzada.",
      },
      preview: {
        injuryImpact: "Reporte de lesiones",
        opponentRank: "Ranking defensivo del rival",
        recordPlaceholder: "100% ⋅ 00 de los últimos 00 partidos",
        opponentRankPlaceholder: "00.º • Positivo",
        weatherPlaceholder: "Nublado",
      },
      weatherDirections: {
        inToOut: "De adentro hacia afuera",
        outToRight: "De afuera hacia la derecha",
        outToIn: "De afuera hacia adentro",
        inFromLeft: "De adentro desde la izquierda",
        inFromRight: "De adentro desde la derecha",
        leftToRight: "De izquierda a derecha",
        outToLeft: "De afuera hacia la izquierda",
        rightToLeft: "De derecha a izquierda",
        unknown: "Desconocido",
      },
      hints: {
        addTrendToMyPicks: "Agrega esta tendencia a Mis Picks para hacer tu apuesta",
        swipeToAddTrend: "Desliza a la izquierda para agregar rápidamente una tendencia a Mis Picks.",
        swipeAddLabel: "Agregar",
      },
      imageImport: {
        noPicksFound: "No se encontraron picks",
        noPicksBody: "No pudimos identificar picks en esta imagen.",
        analyze: "Analizar",
      },
      gamelog: {
        title: "Gamelog",
        titleWithout: "Partidos jugados sin {{name}}",
        chips: {
          last10: "Últimos 10",
          headToHead: "Cara a cara",
          homeSplits: "Partidos en casa",
          awaySplits: "Partidos fuera",
          versusPitcher: "vs. {{pitcher}}",
        },
        headers: {
          hit: "Acierto",
          date: "Fecha",
          versus: "Rival",
          result: "Resultado",
          comp: "Comp",
        },
      },
    },
    stats: {
      sections: {
        records: "Récords",
        headToHead: "Cara a cara",
        last5Games: "Últimos 5 partidos",
        rankings: "Rankings",
        injuries: "Lesiones",
        gameDetails: "Detalles del partido",
      },
      picker: {
        season: "Temporada",
        last5: "Últimos 5",
        headToHead: "Cara a cara",
      },
      rows: {
        recentForm: "Últimos 5 partidos",
        season: "Copa Mundial 2026",
        overall: "General",
        home: "Local",
        away: "Visitante",
      },
      rankings: {
        for: "A FAVOR",
        against: "EN CONTRA",
      },
    },
  },
};
